/* src/app/sidebar-horizontal/sidebar-horizontal.component.css */
.navbar .navbar-nav .nav-item.active .nav-link:focus {
  color: #9CD41C;
  background-color: rgba(255, 255, 255, 0.1);
}
.navbar .collapse .navbar-nav .nav-item .nav-link {
  margin-left: 0px;
}
/*# sourceMappingURL=sidebar-horizontal.component.css.map */
